import { createPost } from '@eshop/api-client'

import { getSearchCompanyTag } from '#/local/service/searchReport'

const searchReportEshop = (itemId: string) => {
    const post = createPost('search')
    const companyTag = getSearchCompanyTag()

    post(`/${companyTag}/products/add-to-cart?item_id=${itemId}`)
        .catch((error) => {
            console.error('[GlobalListener-SearchReportEshop]:', error)
        })
}
export default searchReportEshop
